import { StepBasics } from "@/components/setup/step-basics";
import { StepDj } from "@/components/setup/step-dj";
import { StepDone } from "@/components/setup/step-done";
import { StepLook } from "@/components/setup/step-look";
import { StepMenu } from "@/components/setup/step-menu";
import { StepTimeline } from "@/components/setup/step-timeline";
import type { SetupStepId, SetupStepProps } from "@/components/setup/steps";

/**
 * Renders one setup step. Shared by the linear first-run wizard and the
 * order dashboard's inline editing.
 */
export function StepEditor({
  step,
  ...stepProps
}: { step: SetupStepId } & SetupStepProps) {
  switch (step) {
    case "basics":
      return <StepBasics {...stepProps} />;
    case "look":
      return <StepLook {...stepProps} />;
    case "menu":
      return <StepMenu {...stepProps} />;
    case "timeline":
      return <StepTimeline {...stepProps} />;
    case "dj":
      return <StepDj {...stepProps} />;
    case "done":
      return <StepDone {...stepProps} />;
  }
}
